module.exports = __webpack_public_path__ + "static/media/hp1.afa40cc9.jpeg";